export const requestSelector = (state, name) =>
  (state.http || state)[name];